import { IComponentOptions } from 'angular';
import nvSdcModule from '../../../../nv.sdcModule.module';
import { GridColumnGroupCtrl } from './grid-column-group.controller';

export const GridColumnGroupComponent: IComponentOptions = {
  template: require('./grid-column-group.html'),
  bindings: {
    group: '=',
    allSelectedCols: '=',
  },
  controller: GridColumnGroupCtrl,
};

angular.module(nvSdcModule).component('nvColumnGroup', GridColumnGroupComponent);
